import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { IFinancialSecurityGetDTO, IFinancialSecurityViewDTO } from "../../coreapi-dto/dirs/financialSecurity";


interface IFinancialSecurityCreate extends IFinancialSecurityGetDTO {
}
interface IFinancialSecurityUpdate extends IFinancialSecurityGetDTO{
}

class FinancialSecurityRequest extends BaseDirRequest<IFinancialSecurityViewDTO, IFinancialSecurityGetDTO> {

    constructor(baseUrl:string, token:string, eventHandler: IRequestEventHandler){
        super(baseUrl, "FinancialSecurity", token, eventHandler)
    }

    create(body: IFinancialSecurityCreate, callback: (e:CoreApiResponse<string>)=>void){
        super.create(body,callback)
    }
    
    update(idGlobal:string, body: IFinancialSecurityUpdate, callback: (e:CoreApiResponse<null>)=>void){
        super.update(idGlobal,body,callback)
    }
}

export default FinancialSecurityRequest